package game.controller

import Button
import com.soywiz.korev.Key
import com.soywiz.korge.input.Input
import com.soywiz.korio.util.OS
import game.*
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import view.Terminal

class SettingsController : GameController() {
    private lateinit var keyboardButton: Button
    private lateinit var languageButton: Button
    private lateinit var titleRoom: Room

    override fun onActivate(game: Game) {
        titleRoom = game.getRoomById("title")

        addButton("X", 71, 2, 5, 3) {
            it.controller = nextController
        }

        addCheckBox(
            game.text("Settings_FullScreen"),
            6,
            9,
            20,
            1,
            game.settings.fullScreen
        ) { checked, g ->
            g.settings.fullScreen = checked
        }

        addCheckBox(
            game.text("Settings_Sound"),
            6,
            10,
            20,
            1,
            !game.settings.mute
        ) { checked, g ->
            g.settings.mute = !checked
        }

        addCheckBox(
            game.text("Setting_SoundFootSteps"),
            10,
            11,
            20,
            1,
            !game.settings.muteSteps
        ) { checked, g ->
            g.settings.muteSteps = !checked
        }

//        addLabel(game.text("Settings_Language"), 6, 13, 5, 5)
//        languageButton = addButton(game.text(game.settings.language.name), 22, 12, 20, 3) {
//            var ordinal = game.settings.language.ordinal + 1
//
//            if (ordinal >= Language.values().size) {
//                ordinal = 0
//            }
//
//            game.settings.language = Language.values()[ordinal]
//
//            languageButton.text = game.settings.language.name
//        }

        addLabel(game.text("Settings_Keyboard"), 6, 16, 5, 5)
        keyboardButton = addButton(game.text(game.settings.keyboard.name), 22, 15, 20, 3) {
            var ordinal = game.settings.keyboard.ordinal + 1

            if (ordinal >= Keyboard.values().size) {
                ordinal = 0
            }

            game.settings.keyboard = Keyboard.values()[ordinal]

            keyboardButton.text = game.text(game.settings.keyboard.name)
        }

        addButton(game.text("Settings_QuitTitle"), 5, 20, 26, 3) {
            game.controller = TitleController()
        }

        if (!OS.isJsBrowser) {
            addButton(game.text("Settings_QuitDesktop"), 35, 20, 26, 3) {
                game.quit()
            }
        }
    }

    override fun onDeactivate(game: Game) {
        GlobalScope.launch {
            saveSettings(game.settings)
        }
    }

    override fun onTick(game: Game, input: Input) {
        if (input.keys.justPressed(Key.ESCAPE) || input.keys.justPressed(Key.F10)) {
            game.controller = nextController
        }
    }

    override fun onRender(game: Game, terminal: Terminal) {
        terminal.clear(CgaColor.BLACK)
        terminal.drawDoubleBorder(0, 0, 79, 24, CgaColor.YELLOW, CgaColor.BLACK)
        titleRoom.render(terminal, 3, 2, 0, 10, 50, 3)
        terminal.drawString(7, 6, game.text("Title_Tag"), CgaColor.LIGHT_GRAY, CgaColor.BLACK)
        val copyright = game.text("Copyright")
        terminal.drawString(78 - copyright.length, 24, copyright, CgaColor.YELLOW, CgaColor.BLACK)

        terminal.drawSingleBorder(44, 11, 76, 17, CgaColor.YELLOW)
        terminal.drawText(game.text("Settings_Save"), 46, 12, 74, 2, CgaColor.YELLOW, CgaColor.BLACK)
        terminal.drawString(6, 11, " \u00c0\u00c4\u00c4", CgaColor.LIGHT_GRAY, CgaColor.BLACK)
    }
}